export default __webpack_public_path__ + "static/media/formsign_img2.08237a73.png";